import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'period',
  standalone: true
})
export class PeriodPipe implements PipeTransform {

  transform(value: string): string {
    // Regular expressions to match the different period components
    const regex = /^P(?:(\d+)Y)?(?:(\d+)M)?(?:(\d+)W)?(?:(\d+)D)?$/;
    const match = value?.match(regex);

    if (!match) {
      return '-';
    }

    const years = match[1] ? `${match[1]} year${parseInt(match[1], 10) > 1 ? 's' : ''}` : '';
    const months = match[2] ? `${match[2]} Monate${parseInt(match[2], 10) > 1 ? 's' : ''}` : '';
    const weeks = match[3] ? `${match[3]} week${parseInt(match[3], 10) > 1 ? 's' : ''}` : '';
    const days = match[4] ? `${match[4]} day${parseInt(match[4], 10) > 1 ? 's' : ''}` : '';

    // Concatenate the parts together with a space separator
    return [years, months, weeks, days].filter(Boolean).join(' ') || '0 Tage';
  }

}
